import { Progress, ProgressProps } from "semantic-ui-react";

type BPProgressProps = ProgressProps & {};

export function BPProgress(props: BPProgressProps) {
    return <Progress {...props}>{props.children}</Progress>;
}